import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { TAB_EXTERNAL_STATUS_MAP, TABS } from 'apps/fleet-planner/constants/loads'
import { ILoadFilters } from 'apps/fleet-planner/types/loads'

export const FETCH_LOAD_COUNTS_ACTION_TYPES = generateApiActionTypes('FETCH_LOAD_COUNTS')
export const fetchLoadCounts = (allFilters: ILoadFilters) => {
  const filters = { ...allFilters, status: undefined }
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: FP_ENDPOINTS.statusCounts,
        method: 'GET',
        params: {
          filters,
          statuses: TABS.map(tab => {
            const statuses = TAB_EXTERNAL_STATUS_MAP[tab]

            if (Array.isArray(statuses) && statuses?.length === 0) {
              return ['all']
            }
            return statuses
          }),
        },
      },
      actionTypes: Object.keys(FETCH_LOAD_COUNTS_ACTION_TYPES),
    },
    type: '',
  }
}
